import React, { ReactNode } from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  showArrow?: boolean;
};
export function Button({
  children,
  onClick,
  variant = 'primary',
  disabled = false,
  fullWidth = false,
  className = '',
  showArrow = true
}: ButtonProps) {
  const base = 'group inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full px-7 text-[15px] font-semibold transition-[background-color,color,opacity,transform] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-paper active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-35 disabled:active:scale-100';
  const styles = variant === 'primary' ? 'bg-accent-fill text-on-accent hover:bg-accent-fill/85' : 'border border-ink/25 bg-transparent text-ink hover:bg-ink/5';
  return <button type="button" onClick={onClick} disabled={disabled} className={`${base} ${styles} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-6" data-mp="d3taihqpwipx">
      {children}
      {showArrow && <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5 group-disabled:translate-x-0" data-id="element-7" data-mp="8aqn6rcja5i6" />}
    </button>;
}